<div class="transport-routing">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc-yard.common.transport-routing.title"></sc-dictionary-label>
    </h2>


    <div class="top-info">
      <app-transport-info-panel [carrier]="transportRouting.carrier" [identifier]="transportRouting.identifier"
        [driver]="transportRouting.name" [scope]="transportRouting.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">

      <form class="form" [formGroup]="form">
        <sc-flex>
          <mat-checkbox name="useAsShuttle" formControlName="useAsShuttle" (ngModelChange)="onModelChanged()"
            *ngIf="shuttleTransportsEnabled">
            <sc-dictionary-label dictionaryKey="tmc-yard.common.transport-routing.routingPosition.use-as-shuttle"></sc-dictionary-label>
          </mat-checkbox>
          
          <sc-content-spacer></sc-content-spacer>
          
          <sc-button (click)="reloadRoute()" iconClass="fa-sync-alt" dictionaryKey="tmc-yard.transport-routing.ui.edit-route.reload-positions">
          </sc-button>

          <sc-content-spacer></sc-content-spacer>
          
          <mat-checkbox name="changeRouteManually" formControlName="changeRouteManually"
            [disabled]="transportRouting.changeRouteManually" (ngModelChange)="onModelChanged()">
            <sc-dictionary-label dictionaryKey="tmc-yard.common.transport-routing.routingPosition.change-route-manually"></sc-dictionary-label>
          </mat-checkbox>
        </sc-flex>
        
        <div class="form-box">
          <div class="draggable-form-box margin-bottom20 grid" *ngFor="let position of getNonChangeableRoutings()">

            <div>
              <sc-flex centered>
                <app-routing-position-editor [routingPosition]="position" [disabled]="true"/>
                <button mat-icon-button class="small-button remove-button" [disabled]="true">
                  <sc-icon iconClass="fa-minus"></sc-icon>
                </button>
              </sc-flex>
            </div>


          </div>
        </div>

        <div class="form-box" cdkDropList (cdkDropListDropped)="drop($event)">
          <div class="draggable-form-box grid def" cdkDrag [cdkDragDisabled]="!transportRouting.changeRouteManually"
            *ngFor="let position of getChangeableRoutings()">

            <div>
              <sc-flex centered>
                <app-routing-position-editor [routingPosition]="position" (changed)="positionUpdated(position)" />
                <button mat-icon-button class="small-button remove-button" (click)="removePosition(position)">
                  <sc-icon iconClass="fa-minus"></sc-icon>
                </button>
              </sc-flex>
            </div>

          </div>
        </div>

        <sc-content-spacer vertical></sc-content-spacer>

        <sc-flex centered>
          <sc-action-icon (click)="addPosition()" iconClass="fa-circle-plus" [disabled]="isLoading || !transportRouting.changeRouteManually" large></sc-action-icon>
        </sc-flex>

      </form>
    </div>


    <div class="messages">
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>

    <sc-actionbar>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-cancel-button class="cancel-button" (click)="cancel()"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-save-button primary (click)="save()" class="confirm-button" [disabled]="isSaveDisabled"></sc-save-button>
    </sc-actionbar>
  </div>
</div>
